export const getPendingPayment = (order) => {
  if (order.payment_status === 0) {
    return order.total_amount;
  } else if (order.payment_status === 1) {
    if (
      order.transactionDetails.length &&
      order.transactionDetails[order.transactionDetails.length - 1].type ===
        "PAYLATER"
    ) {
      return order.transactionDetails[order.transactionDetails.length - 1]
        .amount;
    } else if (
      order.transactionDetails.length &&
      order.transactionDetails[order.transactionDetails.length - 1].type ===
        "PAYMENT" &&
      order.transactionDetails[order.transactionDetails.length - 1].paid ===
        false
    ) {
      return order.transactionDetails[order.transactionDetails.length - 1]
        .amount;
    }
  }
  return false;
};
